module.exports = __webpack_public_path__ + "img/1.b167db72.png";